import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import './index.css';


ReactDOM.render(<App/>, document.querySelector('#root'));